import { render } from "./HomePage.vue?vue&type=template&id=e9c7fca0&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=e9c7fca0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Danka\\Desktop\\VUE PORTAL\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c7fca0"]])

export default __exports__